import { motion } from "framer-motion";
import { ArrowRight, Check, Gift } from "lucide-react";
import Reveal from "@/components/site/Reveal";
import Countdown from "@/components/site/Countdown";
import { CHECKOUT_URL, PRICE_NEW, PRICE_OLD } from "@/constants/site";

const included = [
  "Ebook Plano 40+ — 21 Dias para Recomeçar (12 capítulos)",
  "Bônus: guia dos erros comuns",
  "Exercícios e checklists práticos em cada capítulo",
  "Roteiro de consolidação para os próximos 30 dias",
  "Acesso imediato e vitalício, em qualquer dispositivo",
];

const FinalCta = () => (
  <section id="oferta" data-testid="final-cta-section" className="px-4 pb-24 pt-4 sm:px-6 lg:px-8 lg:pb-32">
    <Reveal>
      <div className="relative mx-auto max-w-7xl overflow-hidden rounded-[2rem] bg-primary px-6 py-20 text-primary-foreground sm:px-12 lg:px-20 lg:py-28">
        <span
          aria-hidden="true"
          className="text-outline-light pointer-events-none absolute -bottom-16 -right-6 select-none font-display text-[11rem] font-bold leading-none lg:text-[18rem]"
        >
          21
        </span>

        <div className="relative grid grid-cols-1 gap-14 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <p className="eyebrow mb-6 text-accent">Oferta de lançamento</p>
            <h2 className="font-display text-4xl font-semibold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
              O seu recomeço
              <br />
              <span className="italic text-secondary">começa hoje.</span>
            </h2>
            <p className="mt-7 max-w-lg text-lg leading-relaxed text-primary-foreground/75">
              Daqui a 21 dias, você pode estar exatamente onde está — ou pode ter dado o primeiro
              passo de um método feito para o seu corpo de agora.
            </p>

            <div className="mt-10 flex flex-wrap items-end gap-x-8 gap-y-4">
              <div>
                <p className="font-mono-accent text-sm text-primary-foreground/50 line-through">
                  de {PRICE_OLD}
                </p>
                <p className="font-display text-6xl font-bold text-secondary">{PRICE_NEW}</p>
              </div>
              <p className="max-w-[12rem] pb-2 text-sm leading-snug text-primary-foreground/70">
                pagamento único, sem mensalidade
              </p>
            </div>

            <Countdown />

            <a
              data-testid="final-cta-checkout-button"
              href={CHECKOUT_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-shine group mt-10 inline-flex items-center gap-3 rounded-full bg-accent px-9 py-4 text-base font-semibold text-accent-foreground transition-[transform,box-shadow] duration-300 hover:-translate-y-0.5 hover:shadow-2xl"
            >
              Garantir meu Plano 40+
              <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" />
            </a>

            <div className="mt-8 flex items-center gap-5">
              <motion.img
                src="/assets/selo-garantia.png"
                alt="Selo de garantia: compra garantida, 7 dias, 100% seguro"
                data-testid="guarantee-seal-icon"
                className="h-24 w-24 drop-shadow-xl"
                initial={{ opacity: 0, scale: 0.6, rotate: -12 }}
                whileInView={{ opacity: 1, scale: 1, rotate: 0 }}
                viewport={{ once: true }}
                transition={{ type: "spring", stiffness: 140, damping: 14, delay: 0.3 }}
              />
              <p className="max-w-[17rem] text-sm leading-snug text-primary-foreground/75">
                <strong className="font-semibold text-secondary">Garantia incondicional de 7 dias.</strong>{" "}
                Se não for para você, devolvemos 100% do valor — sem perguntas.
              </p>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="rounded-2xl border border-primary-foreground/15 bg-primary-foreground/5 p-8 backdrop-blur-sm">
              <p className="eyebrow mb-6 flex items-center gap-2 text-secondary">
                <Gift className="h-4 w-4" />
                Tudo o que você recebe
              </p>
              <ul className="space-y-4">
                {included.map((item) => (
                  <li key={item} className="flex items-start gap-3 text-primary-foreground/85">
                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-accent/20">
                      <Check className="h-3 w-3 text-secondary" />
                    </span>
                    <span className="text-sm leading-relaxed sm:text-base">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Reveal>
  </section>
);

export default FinalCta;
